export default "__VITE_ASSET__BbtwGh23__";